module.exports = __webpack_public_path__ + "static/media/peach.93a05ce6.jpg";